module.exports = __webpack_public_path__ + "img/Logo_corner_top_left.10626307.jpg";